// The glyphs that stand in for an attachment in the DS chip's thumbnail slot.
// Shared so the composer and the sent message mark the same file the same way:
// the composer still holds the bytes and shows a real image thumbnail, but a
// sent message carries metadata only (PromptAttachmentMeta has no `data`), so an
// image there falls back to ImageGlyph rather than a preview.
//
// Sized by the slot, which paints them at 100% of a 1.7rem box, so neither
// carries width or height of its own.

export function FileGlyph() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path strokeLinecap="round" strokeLinejoin="round" d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5Z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M14 3v5h5" />
    </svg>
  );
}

export function ImageGlyph() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <rect x="3.5" y="5" width="17" height="14" rx="2" />
      <circle cx="9" cy="10" r="1.5" />
      <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 17 4.5-4.5 3.5 3.5 3-2.5 4 3.5" />
    </svg>
  );
}
